// @ts-nocheck
document.addEventListener('DOMContentLoaded', () => {
  const hoursBlocks = document.querySelectorAll('.store-detail__hours');

  hoursBlocks.forEach((block) => {
    const wrap   = block.querySelector('.store-detail__hours-close-wrap');
    const toggle = block.querySelector('.store-detail__hours-toggle');
    if (!wrap || !toggle) return;

    wrap.addEventListener('click', (e) => {
      if (e.target.closest('.store-detail__hours-flyout')) return;
      const isOpen = block.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  // ── Media carousel – Swiper ───────────────────────────────────────────────
  const mediaEl = document.querySelector('.store-detail__media-row');
  if (mediaEl) {
    const swiper = new Swiper(mediaEl, {
      loop: true,
      slidesPerView: 3,
      spaceBetween: 22,
      breakpoints: {
        0:   { slidesPerView: 1.2, spaceBetween: 14 },
        768: { slidesPerView: 3,   spaceBetween: 22 },
      },
      on: {
        slideChange() {
          document.querySelectorAll('.store-detail__media-dot')
            .forEach((dot, i) => dot.classList.toggle('is-active', i === this.realIndex));
        },
      },
    });
    document.querySelectorAll('.store-detail__media-dot').forEach((dot, i) => {
      dot.addEventListener('click', () => swiper.slideToLoop(i));
    });
  }

  // ── Share icon – copy current URL or use Web Share API ───────────────────
  const shareIcon = document.querySelector('.store-detail__share-icon');
  if (shareIcon) {
    shareIcon.addEventListener('click', () => {
      const url = window.location.href;
      if (navigator.share) {
        navigator.share({ url }).catch(() => {});
      } else {
        navigator.clipboard.writeText(url).then(() => {
          shareIcon.classList.add('is-copied');
          setTimeout(() => shareIcon.classList.remove('is-copied'), 2000);
        }).catch(() => {});
      }
    });
  }

  // ── Highlight today's row in the hours flyout ─────────────────────────────
  const jsDayToIndex = [6, 0, 1, 2, 3, 4, 5];
  const todayIndex   = jsDayToIndex[new Date().getDay()];
  document.querySelectorAll('.store-detail__hours-row-detail').forEach((row) => {
    if (parseInt(row.getAttribute('data-day-index') || '-1', 10) === todayIndex) {
      row.classList.add('is-today');
    }
  });

  // ── Open/closed indicator based on current time ───────────────────────────
  const parseHour = (timeText) => {
    if (!timeText) return null;
    const match = timeText.trim().match(/^(\d+)(am|pm)$/i);
    if (!match) return null;
    let hour      = parseInt(match[1], 10);
    const period  = match[2].toLowerCase();
    if (period === 'pm' && hour !== 12) hour += 12;
    if (period === 'am' && hour === 12) hour = 0;
    return hour;
  };

  const statusEls = document.querySelectorAll('.store-detail__info-open');
  if (statusEls.length) {
    const now         = new Date();
    const currentHour = now.getHours();
    statusEls.forEach((el) => {
      const openTimeAttr  = el.getAttribute('data-open-time') || '';
      const closeTimeAttr = el.getAttribute('data-close-time') || '';
      const openHour      = parseHour(openTimeAttr);
      const closeHour     = parseHour(closeTimeAttr);
      if (openHour == null || closeHour == null) return;
      const isOpen = currentHour >= openHour && currentHour < closeHour;
      el.textContent = isOpen ? 'Open' : 'Closed';
      el.classList.toggle('is-open', isOpen);
      el.classList.toggle('is-closed', !isOpen);
      const timeEl = el.parentElement?.querySelector('.store-detail__status-time');
      if (timeEl) {
        timeEl.textContent = isOpen ? `Closes ${closeTimeAttr}` : `Opens ${openTimeAttr}`;
      }
    });
  }
});
